import { UPGRADE_NAVIGATE_EVENT, UPGRADE_PATH } from "@/utils/upgradeEntry"
import { useEffect } from "react"
import { useNavigate } from "react-router"

/**
 * Renders nothing. Opens /upgrade when a non-React entry point (the limit
 * toasts) asks for it via requestInAppUpgrade. Mounted inside the router.
 */
export const UpgradeNavigationListener: React.FC = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const open = () => void navigate(UPGRADE_PATH)
    window.addEventListener(UPGRADE_NAVIGATE_EVENT, open)
    return () => window.removeEventListener(UPGRADE_NAVIGATE_EVENT, open)
  }, [navigate])

  return null
}
